// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KjKM","col":"styles_col__1gzn7"};